const PopUpCustomerCalendar = ({onClick}) => {
    return (
        <div className={"pop-up-base-style active"}>
			<div className={"pop-up-user-delete"}>
				<img  className={"cross-close"} onClick={onClick} src={"/images/pictos/cross-close.svg"}/>
				<h4 style={{marginBottom: "10px"}}>Visualisation calendrier</h4>
                <span className="text-primary color-red" style={{textAlign:"center", marginBottom:"30px"}}>La date de visite de l'ingénieur structure sera à prendre juste après le règlement de l'acompte en fonction de vos disponibilités</span>

				<div className={"pop-up-user-delete-buttons"} style={{justifyContent: "center"}}>
					<button className={"btn btn-cancel"} onClick={onClick}>Fermer</button>
				</div>
			</div>
		</div>
    )
}

export default PopUpCustomerCalendar;